// extracted by mini-css-extract-plugin
export default {"box":"PerfilesTab_box__m2PMM","hideBox":"PerfilesTab_hideBox__Wd+43"};